import styled from 'styled-components'
import measures from 'globals/measures'
import colors from 'globals/colors'

interface MenuItemWrapperProps {
  active: boolean
}

export const MenuItemWrapper = styled.div<MenuItemWrapperProps>`
  line-height: 18px;
  color: white;
  border-radius: 4px;
  padding: 0 11px;
  margin-bottom: 34px;
  display: flex;
  align-items: center;
  cursor: pointer;

  ${(props) =>
    props.active &&
    `
    padding-top: 8px;
    padding-bottom: 8px;
    background: rgba(255, 255, 255, 0.2);
  `};

  &:hover {
    font-weight: bold;
  }

  @media (max-width: ${measures.tabletThreshold}px) {
    line-height: 50px;
    color: ${colors.purple};
    font-family: 'Publico Roman';
    font-size: 18px;
    padding: 0;
    margin: 0;

    ${(props) =>
      props.active &&
      `
      font-weight: bold;
    `};
  }
`

export const IconWrapper = styled.div`
  width: 33px;

  @media (max-width: ${measures.mobileThreshold}px) {
    display: none;
  }
`
